import accelerationGaugeMedium from './acceleration-gauge--medium.svg';
import accelerationGaugeSmall from './acceleration-gauge--small.svg';
import accountMedium from './account--medium.svg';
import accountSmall from './account--small.svg';
import accountLoggedInMedium from './account-logged-in--medium.svg';
import accountLoggedInSmall from './account-logged-in--small.svg';
import accountCameraMedium from './account-camera--medium.svg';
import accountCameraSmall from './account-camera--small.svg';
import accountShopMedium from './account-shop--medium.svg';
import accountShopSmall from './account-shop--small.svg';
import accountSupportMedium from './account-support--medium.svg';
import accountSupportSmall from './account-support--small.svg';
import addressBookMedium from './address-book--medium.svg';
import addressBookSmall from './address-book--small.svg';
import alertMedium from './alert--medium.svg';
import alertSmall from './alert--small.svg';
import appointmentMedium from './appointment--medium.svg';
import appointmentSmall from './appointment--small.svg';
import arFunctionMedium from './ar-function--medium.svg';
import arFunctionSmall from './ar-function--small.svg';
import arrowDownMedium from './arrow-down--medium.svg';
import arrowDownSmall from './arrow-down--small.svg';
import arrowLeftMedium from './arrow-left--medium.svg';
import arrowLeftSmall from './arrow-left--small.svg';
import arrowRightMedium from './arrow-right--medium.svg';
import arrowRightSmall from './arrow-right--small.svg';
import arrowUpMedium from './arrow-up--medium.svg';
import arrowUpSmall from './arrow-up--small.svg';
import avoidMotorwaysMedium from './avoid-motorways--medium.svg';
import avoidMotorwaysSmall from './avoid-motorways--small.svg';
import avoidTollsMedium from './avoid-tolls--medium.svg';
import avoidTollsSmall from './avoid-tolls--small.svg';
import batteryMedium from './battery--medium.svg';
import batterySmall from './battery--small.svg';
import bellMedium from './bell--medium.svg';
import bellSmall from './bell--small.svg';
import bluetoothControlsMedium from './bluetooth-controls--medium.svg';
import bluetoothControlsSmall from './bluetooth-controls--small.svg';
import burgerMenuMedium from './burger-menu--medium.svg';
import burgerMenuSmall from './burger-menu--small.svg';
import calculatorMedium from './calculator--medium.svg';
import calculatorSmall from './calculator--small.svg';
import calendarMedium from './calendar--medium.svg';
import calendarSmall from './calendar--small.svg';
import callMedium from './call--medium.svg';
import callSmall from './call--small.svg';
import carMedium from './car--medium.svg';
import carSmall from './car--small.svg';
import carPairingMedium from './car-pairing--medium.svg';
import carPairingSmall from './car-pairing--small.svg';
import cardUiPaymentMedium from './card-ui-payment--medium.svg';
import cardUiPaymentSmall from './card-ui-payment--small.svg';
import cashPaymentMedium from './cash-payment--medium.svg';
import cashPaymentSmall from './cash-payment--small.svg';
import chargeBatteryActiveMedium from './charge-battery-active--medium.svg';
import chargeBatteryActiveSmall from './charge-battery-active--small.svg';
import chargeBatteryInactiveMedium from './charge-battery-inactive--medium.svg';
import chargeBatteryInactiveSmall from './charge-battery-inactive--small.svg';
import chargingReportsUiInvoice2Medium from './charging-reports-ui-invoice-2--medium.svg';
import chargingReportsUiInvoice2Small from './charging-reports-ui-invoice-2--small.svg';
import checkboxErrorMedium from './checkbox-error--medium.svg';
import checkboxErrorSmall from './checkbox-error--small.svg';
import checkboxSemiActiveMedium from './checkbox-semi-active--medium.svg';
import checkboxSemiActiveSmall from './checkbox-semi-active--small.svg';
import chevronCompactDownMedium from './chevron-compact-down--medium.svg';
import chevronCompactDownSmall from './chevron-compact-down--small.svg';
import chevronCompactLeftMedium from './chevron-compact-left--medium.svg';
import chevronCompactLeftSmall from './chevron-compact-left--small.svg';
import chevronCompactRightMedium from './chevron-compact-right--medium.svg';
import chevronCompactRightSmall from './chevron-compact-right--small.svg';
import chevronCompactUpMedium from './chevron-compact-up--medium.svg';
import chevronCompactUpSmall from './chevron-compact-up--small.svg';
import chevronDownMedium from './chevron-down--medium.svg';
import chevronDownSmall from './chevron-down--small.svg';
import chevronLeftMedium from './chevron-left--medium.svg';
import chevronLeftSmall from './chevron-left--small.svg';
import chevronRightMedium from './chevron-right--medium.svg';
import chevronRightSmall from './chevron-right--small.svg';
import chevronUpMedium from './chevron-up--medium.svg';
import chevronUpSmall from './chevron-up--small.svg';
import chevronUpDownMedium from './chevron-up-down--medium.svg';
import chevronUpDownSmall from './chevron-up-down--small.svg';
import climateActiveMedium from './climate-active--medium.svg';
import climateActiveSmall from './climate-active--small.svg';
import climateInactiveMedium from './climate-inactive--medium.svg';
import climateInactiveSmall from './climate-inactive--small.svg';
import closeWithCircleMedium from './close-with-circle--medium.svg';
import closeWithCircleSmall from './close-with-circle--small.svg';
import closeWithoutCircleMedium from './close-without-circle--medium.svg';
import closeWithoutCircleSmall from './close-without-circle--small.svg';
import closedCaptionsMedium from './closed-captions--medium.svg';
import closedCaptionsSmall from './closed-captions--small.svg';
import compareMedium from './compare--medium.svg';
import compareSmall from './compare--small.svg';
import contactMedium from './contact--medium.svg';
import contactSmall from './contact--small.svg';
import contractMedium from './contract--medium.svg';
import contractSmall from './contract--small.svg';
import controlsGuestModeMedium from './controls-guest-mode--medium.svg';
import controlsGuestModeSmall from './controls-guest-mode--small.svg';
import controlsSentryModeMedium from './controls-sentry-mode--medium.svg';
import controlsSentryModeSmall from './controls-sentry-mode--small.svg';
import controlsValetModeMedium from './controls-valet-mode--medium.svg';
import controlsValetModeSmall from './controls-valet-mode--small.svg';
import copyMedium from './copy--medium.svg';
import copySmall from './copy--small.svg';
import dealerLocatorLocationMedium from './dealer-locator-location--medium.svg';
import dealerLocatorLocationSmall from './dealer-locator-location--small.svg';
import deleteMedium from './delete--medium.svg';
import deleteSmall from './delete--small.svg';
import digitalServiceBookMedium from './digital-service-book--medium.svg';
import digitalServiceBookSmall from './digital-service-book--small.svg';
import doorsLockedMedium from './doors-locked--medium.svg';
import doorsLockedSmall from './doors-locked--small.svg';
import doorsUnlockedMedium from './doors-unlocked--medium.svg';
import doorsUnlockedSmall from './doors-unlocked--small.svg';
import downloadMedium from './download--medium.svg';
import downloadSmall from './download--small.svg';
import durationMedium from './duration--medium.svg';
import durationSmall from './duration--small.svg';
import editMedium from './edit--medium.svg';
import editSmall from './edit--small.svg';
import emissionsMedium from './emissions--medium.svg';
import emissionsSmall from './emissions--small.svg';
import enterCodeMedium from './enter-code--medium.svg';
import enterCodeSmall from './enter-code--small.svg';
import errorMedium from './error--medium.svg';
import errorSmall from './error--small.svg';
import existingCustomerMedium from './existing-customer--medium.svg';
import existingCustomerSmall from './existing-customer--small.svg';
import exportsMedium from './exports--medium.svg';
import exportsSmall from './exports--small.svg';
import externalLinkMedium from './external-link--medium.svg';
import externalLinkSmall from './external-link--small.svg';
import eyeMedium from './eye--medium.svg';
import eyeSmall from './eye--small.svg';
import eyeOffMedium from './eye-off--medium.svg';
import eyeOffSmall from './eye-off--small.svg';
import facebookMedium from './facebook--medium.svg';
import facebookSmall from './facebook--small.svg';
import featuresMedium from './features--medium.svg';
import featuresSmall from './features--small.svg';
import filterMedium from './filter--medium.svg';
import filterSmall from './filter--small.svg';
import filterActiveMedium from './filter-active--medium.svg';
import filterActiveSmall from './filter-active--small.svg';
import filterSelectedMedium from './filter-selected--medium.svg';
import filterSelectedSmall from './filter-selected--small.svg';
import findADealershipMedium from './find-a-dealership--medium.svg';
import findADealershipSmall from './find-a-dealership--small.svg';
import flashActiveMedium from './flash-active--medium.svg';
import flashActiveSmall from './flash-active--small.svg';
import flashInactiveMedium from './flash-inactive--medium.svg';
import flashInactiveSmall from './flash-inactive--small.svg';
import fullSizeImageMedium from './full-size-image--medium.svg';
import fullSizeImageSmall from './full-size-image--small.svg';
import garageCarSelectionMedium from './garage-car-selection--medium.svg';
import garageCarSelectionSmall from './garage-car-selection--small.svg';
import geofenceMedium from './geofence--medium.svg';
import geofenceSmall from './geofence--small.svg';
import giftMedium from './gift--medium.svg';
import giftSmall from './gift--small.svg';
import greenEnergyMedium from './green-energy--medium.svg';
import greenEnergySmall from './green-energy--small.svg';
import homeChargingMedium from './home-charging--medium.svg';
import homeChargingSmall from './home-charging--small.svg';
import homeCompanyDirectionMedium from './home-company-direction--medium.svg';
import homeCompanyDirectionSmall from './home-company-direction--small.svg';
import hornActiveMedium from './horn-active--medium.svg';
import hornActiveSmall from './horn-active--small.svg';
import hornInactiveMedium from './horn-inactive--medium.svg';
import hornInactiveSmall from './horn-inactive--small.svg';
import hotlineMedium from './hotline--medium.svg';
import hotlineSmall from './hotline--small.svg';
import iChargingCableMedium from './i-charging-cable--medium.svg';
import iChargingCableSmall from './i-charging-cable--small.svg';
import imageMedium from './image--medium.svg';
import imageSmall from './image--small.svg';
import inCarNavigationMedium from './in-car-navigation--medium.svg';
import inCarNavigationSmall from './in-car-navigation--small.svg';
import indefiniteMedium from './indefinite--medium.svg';
import indefiniteSmall from './indefinite--small.svg';
import indoorMedium from './indoor--medium.svg';
import indoorSmall from './indoor--small.svg';
import infoHideMedium from './info-hide--medium.svg';
import infoHideSmall from './info-hide--small.svg';
import infoLegalMedium from './info-legal--medium.svg';
import infoLegalSmall from './info-legal--small.svg';
import instagramMedium from './instagram--medium.svg';
import instagramSmall from './instagram--small.svg';
import kebabMenuMoreMedium from './kebab-menu-more--medium.svg';
import kebabMenuMoreSmall from './kebab-menu-more--small.svg';
import keyShareNotSharedKeyMedium from './key-share-not-shared-key--medium.svg';
import keyShareNotSharedKeySmall from './key-share-not-shared-key--small.svg';
import keyShareSharedKeyMedium from './key-share-shared-key--medium.svg';
import keyShareSharedKeySmall from './key-share-shared-key--small.svg';
import leasingMedium from './leasing--medium.svg';
import leasingSmall from './leasing--small.svg';
import linkMedium from './link--medium.svg';
import linkSmall from './link--small.svg';
import linkedinMedium from './linkedin--medium.svg';
import linkedinSmall from './linkedin--small.svg';
import liveChatMedium from './live-chat--medium.svg';
import liveChatSmall from './live-chat--small.svg';
import locateMyCarMedium from './locate-my-car--medium.svg';
import locateMyCarSmall from './locate-my-car--small.svg';
import locateMyDeviceMedium from './locate-my-device--medium.svg';
import locateMyDeviceSmall from './locate-my-device--small.svg';
import locationMarkerCarMedium from './location-marker-car--medium.svg';
import locationMarkerCarSmall from './location-marker-car--small.svg';
import locationMarkerDeviceMedium from './location-marker-device--medium.svg';
import locationMarkerDeviceSmall from './location-marker-device--small.svg';
import locationMarkerOtherPoiMedium from './location-marker-other-POI--medium.svg';
import locationMarkerOtherPoiSmall from './location-marker-other-POI--small.svg';
import locationMarkerPublicChargerMedium from './location-marker-public-charger--medium.svg';
import locationMarkerPublicChargerSmall from './location-marker-public-charger--small.svg';
import lockMedium from './lock--medium.svg';
import lockSmall from './lock--small.svg';
import logOutMedium from './log-out--medium.svg';
import logOutSmall from './log-out--small.svg';
import manageColumnsMedium from './manage-columns--medium.svg';
import manageColumnsSmall from './manage-columns--small.svg';
import mapTargetMedium from './map-target--medium.svg';
import mapTargetSmall from './map-target--small.svg';
import maximizeMedium from './maximize--medium.svg';
import maximizeSmall from './maximize--small.svg';
import meatballsMenuMoreMedium from './meatballs-menu-more--medium.svg';
import meatballsMenuMoreSmall from './meatballs-menu-more--small.svg';
import minimizeMedium from './minimize--medium.svg';
import minimizeSmall from './minimize--small.svg';
import minusMedium from './minus--medium.svg';
import minusSmall from './minus--small.svg';
import mirroringMedium from './mirroring--medium.svg';
import mirroringSmall from './mirroring--small.svg';
import newCustomerMedium from './new-customer--medium.svg';
import newCustomerSmall from './new-customer--small.svg';
import newCustomizedCarMedium from './new-customized-car--medium.svg';
import newCustomizedCarSmall from './new-customized-car--small.svg';
import newNotificationWithBadgeMedium from './new-notification-with-badge--medium.svg';
import newNotificationWithBadgeSmall from './new-notification-with-badge--small.svg';
import newsMedium from './news--medium.svg';
import newsSmall from './news--small.svg';
import newsletterMailMedium from './newsletter-mail--medium.svg';
import newsletterMailSmall from './newsletter-mail--small.svg';
import noAuthorizationMedium from './no-authorization--medium.svg';
import noAuthorizationSmall from './no-authorization--small.svg';
import notificationMedium from './notification--medium.svg';
import notificationSmall from './notification--small.svg';
import onMedium from './on--medium.svg';
import onSmall from './on--small.svg';
import openInMapsMedium from './open-in-maps--medium.svg';
import openInMapsSmall from './open-in-maps--small.svg';
import ownersManualMedium from './owners-manual--medium.svg';
import ownersManualSmall from './owners-manual--small.svg';
import parkChargeMedium from './park-charge--medium.svg';
import parkChargeSmall from './park-charge--small.svg';
import parkingComfortModeActiveMedium from './parking-comfort-mode-active--medium.svg';
import parkingComfortModeActiveSmall from './parking-comfort-mode-active--small.svg';
import parkingComfortModeInactiveMedium from './parking-comfort-mode-inactive--medium.svg';
import parkingComfortModeInactiveSmall from './parking-comfort-mode-inactive--small.svg';
import pauseMedium from './pause--medium.svg';
import pauseSmall from './pause--small.svg';
import pegmanMedium from './pegman--medium.svg';
import pegmanSmall from './pegman--small.svg';
import phoneMedium from './phone--medium.svg';
import phoneSmall from './phone--small.svg';
import phoneKeyCarConnectedMedium from './phone-key-car-connected--medium.svg';
import phoneKeyCarConnectedSmall from './phone-key-car-connected--small.svg';
import phoneKeyCarDisconnectedMedium from './phone-key-car-disconnected--medium.svg';
import phoneKeyCarDisconnectedSmall from './phone-key-car-disconnected--small.svg';
import phoneNavigationAppMedium from './phone-navigation-app--medium.svg';
import phoneNavigationAppSmall from './phone-navigation-app--small.svg';
import playButtonMedium from './play-button--medium.svg';
import playButtonSmall from './play-button--small.svg';
import plugChademoMedium from './plug-chademo--medium.svg';
import plugChademoSmall from './plug-chademo--small.svg';
import plugChargeMedium from './plug-charge--medium.svg';
import plugChargeSmall from './plug-charge--small.svg';
import plugCssMedium from './plug-css--medium.svg';
import plugCssSmall from './plug-css--small.svg';
import plugHouseholdAMedium from './plug-household-a--medium.svg';
import plugHouseholdASmall from './plug-household-a--small.svg';
import plugHouseholdEMedium from './plug-household-e--medium.svg';
import plugHouseholdESmall from './plug-household-e--small.svg';
import plugHouseholdFMedium from './plug-household-f--medium.svg';
import plugHouseholdFSmall from './plug-household-f--small.svg';
import plugHouseholdGMedium from './plug-household-g--medium.svg';
import plugHouseholdGSmall from './plug-household-g--small.svg';
import plugHouseholdJMedium from './plug-household-j--medium.svg';
import plugHouseholdJSmall from './plug-household-j--small.svg';
import plugType1Medium from './plug-type-1--medium.svg';
import plugType1Small from './plug-type-1--small.svg';
import plugType2Medium from './plug-type-2--medium.svg';
import plugType2Small from './plug-type-2--small.svg';
import plugType3Medium from './plug-type-3--medium.svg';
import plugType3Small from './plug-type-3--small.svg';
import plusMedium from './plus--medium.svg';
import plusSmall from './plus--small.svg';
import printMedium from './print--medium.svg';
import printSmall from './print--small.svg';
import qrCodeMedium from './qr-code--medium.svg';
import qrCodeSmall from './qr-code--small.svg';
import refreshMedium from './refresh--medium.svg';
import refreshSmall from './refresh--small.svg';
import refreshAirInactiveMedium from './refresh-air-inactive--medium.svg';
import refreshAirInactiveSmall from './refresh-air-inactive--small.svg';
import remoteControlsMedium from './remote-controls--medium.svg';
import remoteControlsSmall from './remote-controls--small.svg';
import restrictedAccessMedium from './restricted-access--medium.svg';
import restrictedAccessSmall from './restricted-access--small.svg';
import reviewsEmptyMedium from './reviews-empty--medium.svg';
import reviewsEmptySmall from './reviews-empty--small.svg';
import reviewsFullMedium from './reviews-full--medium.svg';
import reviewsFullSmall from './reviews-full--small.svg';
import roofMedium from './roof--medium.svg';
import roofSmall from './roof--small.svg';
import satelliteMedium from './satellite--medium.svg';
import satelliteSmall from './satellite--small.svg';
import saveFavouriteMedium from './save-favourite--medium.svg';
import saveFavouriteSmall from './save-favourite--small.svg';
import saveFavouriteFullMedium from './save-favourite-full--medium.svg';
import searchMedium from './search--medium.svg';
import searchSmall from './search--small.svg';
import seatHeatDriveActiveLvl1Medium from './seat-heat-drive-active-lvl1--medium.svg';
import seatHeatDriveActiveLvl1Small from './seat-heat-drive-active-lvl1--small.svg';
import seatHeatDriveActiveLvl2Medium from './seat-heat-drive-active-lvl2--medium.svg';
import seatHeatDriveActiveLvl2Small from './seat-heat-drive-active-lvl2--small.svg';
import seatHeatDriveActiveLvl3Medium from './seat-heat-drive-active-lvl3--medium.svg';
import seatHeatDriveActiveLvl3Small from './seat-heat-drive-active-lvl3--small.svg';
import seatHeatDriveInactiveMedium from './seat-heat-drive-inactive--medium.svg';
import seatHeatDriveInactiveSmall from './seat-heat-drive-inactive--small.svg';
import seatHeatPassengerActiveLvl1Medium from './seat-heat-passenger-active-lvl1--medium.svg';
import seatHeatPassengerActiveLvl1Small from './seat-heat-passenger-active-lvl1--small.svg';
import seatHeatPassengerActiveLvl2Medium from './seat-heat-passenger-active-lvl2--medium.svg';
import seatHeatPassengerActiveLvl2Small from './seat-heat-passenger-active-lvl2--small.svg';
import seatHeatPassengerActiveLvl3Medium from './seat-heat-passenger-active-lvl3--medium.svg';
import seatHeatPassengerActiveLvl3Small from './seat-heat-passenger-active-lvl3--small.svg';
import seatHeatPassengerInactiveMedium from './seat-heat-passenger-inactive--medium.svg';
import seatHeatPassengerInactiveSmall from './seat-heat-passenger-inactive--small.svg';
import sendToCarMedium from './send-to-car--medium.svg';
import sendToCarSmall from './send-to-car--small.svg';
import serviceAppMedium from './service-app--medium.svg';
import serviceAppSmall from './service-app--small.svg';
import settingMedium from './setting--medium.svg';
import settingSmall from './setting--small.svg';
import shareMedium from './share--medium.svg';
import shareSmall from './share--small.svg';
import shoppingCartMedium from './shopping-cart--medium.svg';
import shoppingCartSmall from './shopping-cart--small.svg';
import smartDealerMedium from './smart-dealer--medium.svg';
import smartDealerSmall from './smart-dealer--small.svg';
import sortDefaultMedium from './sort-default--medium.svg';
import sortDefaultSmall from './sort-default--small.svg';
import statusGoodMedium from './status-good--medium.svg';
import statusGoodSmall from './status-good--small.svg';
import steeringWheelHeatActiveMedium from './steering-wheel-heat-active--medium.svg';
import steeringWheelHeatActiveSmall from './steering-wheel-heat-active--small.svg';
import steeringWheelHeatInactiveMedium from './steering-wheel-heat-inactive--medium.svg';
import steeringWheelHeatInactiveSmall from './steering-wheel-heat-inactive--small.svg';
import successfulCheckmarkMedium from './successful-checkmark--medium.svg';
import successfulCheckmarkSmall from './successful-checkmark--small.svg';
import sunshadeClosedMedium from './sunshade-closed--medium.svg';
import sunshadeClosedSmall from './sunshade-closed--small.svg';
import sunshadeOpenMedium from './sunshade-open--medium.svg';
import sunshadeOpenSmall from './sunshade-open--small.svg';
import supportHelpMedium from './support-help--medium.svg';
import supportHelpSmall from './support-help--small.svg';
import switchCountryMedium from './switch-country--medium.svg';
import switchCountrySmall from './switch-country--small.svg';
import terrainMedium from './terrain--medium.svg';
import terrainSmall from './terrain--small.svg';
import testDriveMedium from './test-drive--medium.svg';
import testDriveSmall from './test-drive--small.svg';
import threeDViewMedium from './three-d-view--medium.svg';
import threeDViewSmall from './three-d-view--small.svg';
import tiktokMedium from './tiktok--medium.svg';
import tiktokSmall from './tiktok--small.svg';
import tiresMedium from './tires--medium.svg';
import tiresSmall from './tires--small.svg';
import trailerHitchMedium from './trailer-hitch--medium.svg';
import trailerHitchSmall from './trailer-hitch--small.svg';
import trunkLockedMedium from './trunk-locked--medium.svg';
import trunkLockedSmall from './trunk-locked--small.svg';
import trunkUnlockedMedium from './trunk-unlocked--medium.svg';
import trunkUnlockedSmall from './trunk-unlocked--small.svg';
import twentyfourHOpenMedium from './twentyfour-h-open--medium.svg';
import twentyfourHOpenSmall from './twentyfour-h-open--small.svg';
import twitterMedium from './twitter--medium.svg';
import twitterSmall from './twitter--small.svg';
import unfoldMoreMedium from './unfold-more--medium.svg';
import unfoldMoreSmall from './unfold-more--small.svg';
import unlockMedium from './unlock--medium.svg';
import unlockSmall from './unlock--small.svg';
import uploadMedium from './upload--medium.svg';
import uploadSmall from './upload--small.svg';
import vehicleServiceMaintenanceMedium from './vehicle-service-maintenance--medium.svg';
import vehicleServiceMaintenanceSmall from './vehicle-service-maintenance--small.svg';
import viewExteriorMedium from './view-exterior--medium.svg';
import viewExteriorSmall from './view-exterior--small.svg';
import viewInteriorMedium from './view-interior--medium.svg';
import viewInteriorSmall from './view-interior--small.svg';
import volumeNoSoundMedium from './volume-no-sound--medium.svg';
import volumeNoSoundSmall from './volume-no-sound--small.svg';
import volumeOffMedium from './volume-off--medium.svg';
import volumeOffSmall from './volume-off--small.svg';
import volumeOnMedium from './volume-on--medium.svg';
import volumeOnSmall from './volume-on--small.svg';
import volumeReduceMedium from './volume-reduce--medium.svg';
import volumeReduceSmall from './volume-reduce--small.svg';
import wallboxMedium from './wallbox--medium.svg';
import wallboxSmall from './wallbox--small.svg';
import warningMedium from './warning--medium.svg';
import warningSmall from './warning--small.svg';
import watchWishListMedium from './watch-wish-list--medium.svg';
import watchWishListSmall from './watch-wish-list--small.svg';
import windowsClosedMedium from './windows-closed--medium.svg';
import windowsClosedSmall from './windows-closed--small.svg';
import windowsVentMedium from './windows-vent--medium.svg';
import windowsVentSmall from './windows-vent--small.svg';
import youtubeMedium from './youtube--medium.svg';
import youtubeSmall from './youtube--small.svg';

export const IconNames = {
  'acceleration-gauge--medium': accelerationGaugeMedium,
  'acceleration-gauge--small': accelerationGaugeSmall,
  'account-logged-in--medium': accountLoggedInMedium,
  'account-logged-in--small': accountLoggedInSmall,
  'account--medium': accountMedium,
  'account--small': accountSmall,
  'account-camera--medium': accountCameraMedium,
  'account-camera--small': accountCameraSmall,
  'account-shop--medium': accountShopMedium,
  'account-shop--small': accountShopSmall,
  'account-support--medium': accountSupportMedium,
  'account-support--small': accountSupportSmall,
  'address-book--medium': addressBookMedium,
  'address-book--small': addressBookSmall,
  'alert--medium': alertMedium,
  'alert--small': alertSmall,
  'appointment--medium': appointmentMedium,
  'appointment--small': appointmentSmall,
  'ar-function--medium': arFunctionMedium,
  'ar-function--small': arFunctionSmall,
  'arrow-down--medium': arrowDownMedium,
  'arrow-down--small': arrowDownSmall,
  'arrow-left--medium': arrowLeftMedium,
  'arrow-left--small': arrowLeftSmall,
  'arrow-right--medium': arrowRightMedium,
  'arrow-right--small': arrowRightSmall,
  'arrow-up--medium': arrowUpMedium,
  'arrow-up--small': arrowUpSmall,
  'avoid-motorways--medium': avoidMotorwaysMedium,
  'avoid-motorways--small': avoidMotorwaysSmall,
  'avoid-tolls--medium': avoidTollsMedium,
  'avoid-tolls--small': avoidTollsSmall,
  'battery--medium': batteryMedium,
  'battery--small': batterySmall,
  'bell--medium': bellMedium,
  'bell--small': bellSmall,
  'bluetooth-controls--medium': bluetoothControlsMedium,
  'bluetooth-controls--small': bluetoothControlsSmall,
  'burger-menu--medium': burgerMenuMedium,
  'burger-menu--small': burgerMenuSmall,
  'calculator--medium': calculatorMedium,
  'calculator--small': calculatorSmall,
  'calendar--medium': calendarMedium,
  'calendar--small': calendarSmall,
  'call--medium': callMedium,
  'call--small': callSmall,
  'car--medium': carMedium,
  'car--small': carSmall,
  'car-pairing--medium': carPairingMedium,
  'car-pairing--small': carPairingSmall,
  'card-ui-payment--medium': cardUiPaymentMedium,
  'card-ui-payment--small': cardUiPaymentSmall,
  'cash-payment--medium': cashPaymentMedium,
  'cash-payment--small': cashPaymentSmall,
  'charge-battery-active--medium': chargeBatteryActiveMedium,
  'charge-battery-active--small': chargeBatteryActiveSmall,
  'charge-battery-inactive--medium': chargeBatteryInactiveMedium,
  'charge-battery-inactive--small': chargeBatteryInactiveSmall,
  'charging-reports-ui-invoice-2--medium': chargingReportsUiInvoice2Medium,
  'charging-reports-ui-invoice-2--small': chargingReportsUiInvoice2Small,
  'checkbox-error--medium': checkboxErrorMedium,
  'checkbox-error--small': checkboxErrorSmall,
  'checkbox-semi-active--medium': checkboxSemiActiveMedium,
  'checkbox-semi-active--small': checkboxSemiActiveSmall,
  'chevron-compact-down--medium': chevronCompactDownMedium,
  'chevron-compact-down--small': chevronCompactDownSmall,
  'chevron-compact-left--medium': chevronCompactLeftMedium,
  'chevron-compact-left--small': chevronCompactLeftSmall,
  'chevron-compact-right--medium': chevronCompactRightMedium,
  'chevron-compact-right--small': chevronCompactRightSmall,
  'chevron-compact-up--medium': chevronCompactUpMedium,
  'chevron-compact-up--small': chevronCompactUpSmall,
  'chevron-down--medium': chevronDownMedium,
  'chevron-down--small': chevronDownSmall,
  'chevron-left--medium': chevronLeftMedium,
  'chevron-left--small': chevronLeftSmall,
  'chevron-right--medium': chevronRightMedium,
  'chevron-right--small': chevronRightSmall,
  'chevron-up--medium': chevronUpMedium,
  'chevron-up--small': chevronUpSmall,
  'chevron-up-down--medium': chevronUpDownMedium,
  'chevron-up-down--small': chevronUpDownSmall,
  'climate-active--medium': climateActiveMedium,
  'climate-active--small': climateActiveSmall,
  'climate-inactive--medium': climateInactiveMedium,
  'climate-inactive--small': climateInactiveSmall,
  'close-with-circle--medium': closeWithCircleMedium,
  'close-with-circle--small': closeWithCircleSmall,
  'close-without-circle--medium': closeWithoutCircleMedium,
  'close-without-circle--small': closeWithoutCircleSmall,
  'closed-captions--medium': closedCaptionsMedium,
  'closed-captions--small': closedCaptionsSmall,
  'compare--medium': compareMedium,
  'compare--small': compareSmall,
  'contact--medium': contactMedium,
  'contact--small': contactSmall,
  'contract--medium': contractMedium,
  'contract--small': contractSmall,
  'controls-guest-mode--medium': controlsGuestModeMedium,
  'controls-guest-mode--small': controlsGuestModeSmall,
  'controls-sentry-mode--medium': controlsSentryModeMedium,
  'controls-sentry-mode--small': controlsSentryModeSmall,
  'controls-valet-mode--medium': controlsValetModeMedium,
  'controls-valet-mode--small': controlsValetModeSmall,
  'copy--medium': copyMedium,
  'copy--small': copySmall,
  'dealer-locator-location--medium': dealerLocatorLocationMedium,
  'dealer-locator-location--small': dealerLocatorLocationSmall,
  'delete--medium': deleteMedium,
  'delete--small': deleteSmall,
  'digital-service-book--medium': digitalServiceBookMedium,
  'digital-service-book--small': digitalServiceBookSmall,
  'doors-locked--medium': doorsLockedMedium,
  'doors-locked--small': doorsLockedSmall,
  'doors-unlocked--medium': doorsUnlockedMedium,
  'doors-unlocked--small': doorsUnlockedSmall,
  'download--medium': downloadMedium,
  'download--small': downloadSmall,
  'duration--medium': durationMedium,
  'duration--small': durationSmall,
  'edit--medium': editMedium,
  'edit--small': editSmall,
  'emissions--medium': emissionsMedium,
  'emissions--small': emissionsSmall,
  'enter-code--medium': enterCodeMedium,
  'enter-code--small': enterCodeSmall,
  'error--medium': errorMedium,
  'error--small': errorSmall,
  'existing-customer--medium': existingCustomerMedium,
  'existing-customer--small': existingCustomerSmall,
  'exports--medium': exportsMedium,
  'exports--small': exportsSmall,
  'external-link--medium': externalLinkMedium,
  'external-link--small': externalLinkSmall,
  'eye--medium': eyeMedium,
  'eye--small': eyeSmall,
  'eye-off--medium': eyeOffMedium,
  'eye-off--small': eyeOffSmall,
  'facebook--medium': facebookMedium,
  'facebook--small': facebookSmall,
  'features--medium': featuresMedium,
  'features--small': featuresSmall,
  'filter--medium': filterMedium,
  'filter--small': filterSmall,
  'filter-active--medium': filterActiveMedium,
  'filter-active--small': filterActiveSmall,
  'filter-selected--medium': filterSelectedMedium,
  'filter-selected--small': filterSelectedSmall,
  'find-a-dealership--medium': findADealershipMedium,
  'find-a-dealership--small': findADealershipSmall,
  'flash-active--medium': flashActiveMedium,
  'flash-active--small': flashActiveSmall,
  'flash-inactive--medium': flashInactiveMedium,
  'flash-inactive--small': flashInactiveSmall,
  'full-size-image--medium': fullSizeImageMedium,
  'full-size-image--small': fullSizeImageSmall,
  'garage-car-selection--medium': garageCarSelectionMedium,
  'garage-car-selection--small': garageCarSelectionSmall,
  'geofence--medium': geofenceMedium,
  'geofence--small': geofenceSmall,
  'gift--medium': giftMedium,
  'gift--small': giftSmall,
  'green-energy--medium': greenEnergyMedium,
  'green-energy--small': greenEnergySmall,
  'home-charging--medium': homeChargingMedium,
  'home-charging--small': homeChargingSmall,
  'home-company-direction--medium': homeCompanyDirectionMedium,
  'home-company-direction--small': homeCompanyDirectionSmall,
  'horn-active--medium': hornActiveMedium,
  'horn-active--small': hornActiveSmall,
  'horn-inactive--medium': hornInactiveMedium,
  'horn-inactive--small': hornInactiveSmall,
  'hotline--medium': hotlineMedium,
  'hotline--small': hotlineSmall,
  'i-charging-cable--medium': iChargingCableMedium,
  'i-charging-cable--small': iChargingCableSmall,
  'image--medium': imageMedium,
  'image--small': imageSmall,
  'in-car-navigation--medium': inCarNavigationMedium,
  'in-car-navigation--small': inCarNavigationSmall,
  'indefinite--medium': indefiniteMedium,
  'indefinite--small': indefiniteSmall,
  'indoor--medium': indoorMedium,
  'indoor--small': indoorSmall,
  'info-hide--medium': infoHideMedium,
  'info-hide--small': infoHideSmall,
  'info-legal--medium': infoLegalMedium,
  'info-legal--small': infoLegalSmall,
  'instagram--medium': instagramMedium,
  'instagram--small': instagramSmall,
  'kebab-menu-more--medium': kebabMenuMoreMedium,
  'kebab-menu-more--small': kebabMenuMoreSmall,
  'key-share-not-shared-key--medium': keyShareNotSharedKeyMedium,
  'key-share-not-shared-key--small': keyShareNotSharedKeySmall,
  'key-share-shared-key--medium': keyShareSharedKeyMedium,
  'key-share-shared-key--small': keyShareSharedKeySmall,
  'leasing--medium': leasingMedium,
  'leasing--small': leasingSmall,
  'link--medium': linkMedium,
  'link--small': linkSmall,
  'linkedin--medium': linkedinMedium,
  'linkedin--small': linkedinSmall,
  'live-chat--medium': liveChatMedium,
  'live-chat--small': liveChatSmall,
  'locate-my-car--medium': locateMyCarMedium,
  'locate-my-car--small': locateMyCarSmall,
  'locate-my-device--medium': locateMyDeviceMedium,
  'locate-my-device--small': locateMyDeviceSmall,
  'location-marker-car--medium': locationMarkerCarMedium,
  'location-marker-car--small': locationMarkerCarSmall,
  'location-marker-device--medium': locationMarkerDeviceMedium,
  'location-marker-device--small': locationMarkerDeviceSmall,
  'location-marker-other-POI--medium': locationMarkerOtherPoiMedium,
  'location-marker-other-POI--small': locationMarkerOtherPoiSmall,
  'location-marker-public-charger--medium': locationMarkerPublicChargerMedium,
  'location-marker-public-charger--small': locationMarkerPublicChargerSmall,
  'lock--medium': lockMedium,
  'lock--small': lockSmall,
  'log-out--medium': logOutMedium,
  'log-out--small': logOutSmall,
  'manage-columns--medium': manageColumnsMedium,
  'manage-columns--small': manageColumnsSmall,
  'map-target--medium': mapTargetMedium,
  'map-target--small': mapTargetSmall,
  'maximize--medium': maximizeMedium,
  'maximize--small': maximizeSmall,
  'meatballs-menu-more--medium': meatballsMenuMoreMedium,
  'meatballs-menu-more--small': meatballsMenuMoreSmall,
  'minimize--medium': minimizeMedium,
  'minimize--small': minimizeSmall,
  'minus--medium': minusMedium,
  'minus--small': minusSmall,
  'mirroring--medium': mirroringMedium,
  'mirroring--small': mirroringSmall,
  'new-customer--medium': newCustomerMedium,
  'new-customer--small': newCustomerSmall,
  'new-customized-car--medium': newCustomizedCarMedium,
  'new-customized-car--small': newCustomizedCarSmall,
  'new-notification-with-badge--medium': newNotificationWithBadgeMedium,
  'new-notification-with-badge--small': newNotificationWithBadgeSmall,
  'news--medium': newsMedium,
  'news--small': newsSmall,
  'newsletter-mail--medium': newsletterMailMedium,
  'newsletter-mail--small': newsletterMailSmall,
  'no-authorization--medium': noAuthorizationMedium,
  'no-authorization--small': noAuthorizationSmall,
  'notification--medium': notificationMedium,
  'notification--small': notificationSmall,
  'on--medium': onMedium,
  'on--small': onSmall,
  'open-in-maps--medium': openInMapsMedium,
  'open-in-maps--small': openInMapsSmall,
  'owners-manual--medium': ownersManualMedium,
  'owners-manual--small': ownersManualSmall,
  'park-charge--medium': parkChargeMedium,
  'park-charge--small': parkChargeSmall,
  'parking-comfort-mode-active--medium': parkingComfortModeActiveMedium,
  'parking-comfort-mode-active--small': parkingComfortModeActiveSmall,
  'parking-comfort-mode-inactive--medium': parkingComfortModeInactiveMedium,
  'parking-comfort-mode-inactive--small': parkingComfortModeInactiveSmall,
  'pause--medium': pauseMedium,
  'pause--small': pauseSmall,
  'pegman--medium': pegmanMedium,
  'pegman--small': pegmanSmall,
  'phone--medium': phoneMedium,
  'phone--small': phoneSmall,
  'phone-key-car-connected--medium': phoneKeyCarConnectedMedium,
  'phone-key-car-connected--small': phoneKeyCarConnectedSmall,
  'phone-key-car-disconnected--medium': phoneKeyCarDisconnectedMedium,
  'phone-key-car-disconnected--small': phoneKeyCarDisconnectedSmall,
  'phone-navigation-app--medium': phoneNavigationAppMedium,
  'phone-navigation-app--small': phoneNavigationAppSmall,
  'play-button--medium': playButtonMedium,
  'play-button--small': playButtonSmall,
  'plug-chademo--medium': plugChademoMedium,
  'plug-chademo--small': plugChademoSmall,
  'plug-charge--medium': plugChargeMedium,
  'plug-charge--small': plugChargeSmall,
  'plug-css--medium': plugCssMedium,
  'plug-css--small': plugCssSmall,
  'plug-household-a--medium': plugHouseholdAMedium,
  'plug-household-a--small': plugHouseholdASmall,
  'plug-household-e--medium': plugHouseholdEMedium,
  'plug-household-e--small': plugHouseholdESmall,
  'plug-household-f--medium': plugHouseholdFMedium,
  'plug-household-f--small': plugHouseholdFSmall,
  'plug-household-g--medium': plugHouseholdGMedium,
  'plug-household-g--small': plugHouseholdGSmall,
  'plug-household-j--medium': plugHouseholdJMedium,
  'plug-household-j--small': plugHouseholdJSmall,
  'plug-type-1--medium': plugType1Medium,
  'plug-type-1--small': plugType1Small,
  'plug-type-2--medium': plugType2Medium,
  'plug-type-2--small': plugType2Small,
  'plug-type-3--medium': plugType3Medium,
  'plug-type-3--small': plugType3Small,
  'plus--medium': plusMedium,
  'plus--small': plusSmall,
  'print--medium': printMedium,
  'print--small': printSmall,
  'qr-code--medium': qrCodeMedium,
  'qr-code--small': qrCodeSmall,
  'refresh--medium': refreshMedium,
  'refresh--small': refreshSmall,
  'refresh-air-inactive--medium': refreshAirInactiveMedium,
  'refresh-air-inactive--small': refreshAirInactiveSmall,
  'remote-controls--medium': remoteControlsMedium,
  'remote-controls--small': remoteControlsSmall,
  'restricted-access--medium': restrictedAccessMedium,
  'restricted-access--small': restrictedAccessSmall,
  'reviews-empty--medium': reviewsEmptyMedium,
  'reviews-empty--small': reviewsEmptySmall,
  'reviews-full--medium': reviewsFullMedium,
  'reviews-full--small': reviewsFullSmall,
  'roof--medium': roofMedium,
  'roof--small': roofSmall,
  'satellite--medium': satelliteMedium,
  'satellite--small': satelliteSmall,
  'save-favourite--medium': saveFavouriteMedium,
  'save-favourite--small': saveFavouriteSmall,
  'save-favourite-full--medium': saveFavouriteFullMedium,
  'search--medium': searchMedium,
  'search--small': searchSmall,
  'seat-heat-drive-active-lvl1--medium': seatHeatDriveActiveLvl1Medium,
  'seat-heat-drive-active-lvl1--small': seatHeatDriveActiveLvl1Small,
  'seat-heat-drive-active-lvl2--medium': seatHeatDriveActiveLvl2Medium,
  'seat-heat-drive-active-lvl2--small': seatHeatDriveActiveLvl2Small,
  'seat-heat-drive-active-lvl3--medium': seatHeatDriveActiveLvl3Medium,
  'seat-heat-drive-active-lvl3--small': seatHeatDriveActiveLvl3Small,
  'seat-heat-drive-inactive--medium': seatHeatDriveInactiveMedium,
  'seat-heat-drive-inactive--small': seatHeatDriveInactiveSmall,
  'seat-heat-passenger-active-lvl1--medium': seatHeatPassengerActiveLvl1Medium,
  'seat-heat-passenger-active-lvl1--small': seatHeatPassengerActiveLvl1Small,
  'seat-heat-passenger-active-lvl2--medium': seatHeatPassengerActiveLvl2Medium,
  'seat-heat-passenger-active-lvl2--small': seatHeatPassengerActiveLvl2Small,
  'seat-heat-passenger-active-lvl3--medium': seatHeatPassengerActiveLvl3Medium,
  'seat-heat-passenger-active-lvl3--small': seatHeatPassengerActiveLvl3Small,
  'seat-heat-passenger-inactive--medium': seatHeatPassengerInactiveMedium,
  'seat-heat-passenger-inactive--small': seatHeatPassengerInactiveSmall,
  'send-to-car--medium': sendToCarMedium,
  'send-to-car--small': sendToCarSmall,
  'service-app--medium': serviceAppMedium,
  'service-app--small': serviceAppSmall,
  'setting--medium': settingMedium,
  'setting--small': settingSmall,
  'share--medium': shareMedium,
  'share--small': shareSmall,
  'shopping-cart--medium': shoppingCartMedium,
  'shopping-cart--small': shoppingCartSmall,
  'smart-dealer--medium': smartDealerMedium,
  'smart-dealer--small': smartDealerSmall,
  'sort-default--medium': sortDefaultMedium,
  'sort-default--small': sortDefaultSmall,
  'status-good--medium': statusGoodMedium,
  'status-good--small': statusGoodSmall,
  'steering-wheel-heat-active--medium': steeringWheelHeatActiveMedium,
  'steering-wheel-heat-active--small': steeringWheelHeatActiveSmall,
  'steering-wheel-heat-inactive--medium': steeringWheelHeatInactiveMedium,
  'steering-wheel-heat-inactive--small': steeringWheelHeatInactiveSmall,
  'successful-checkmark--medium': successfulCheckmarkMedium,
  'successful-checkmark--small': successfulCheckmarkSmall,
  'sunshade-closed--medium': sunshadeClosedMedium,
  'sunshade-closed--small': sunshadeClosedSmall,
  'sunshade-open--medium': sunshadeOpenMedium,
  'sunshade-open--small': sunshadeOpenSmall,
  'support-help--medium': supportHelpMedium,
  'support-help--small': supportHelpSmall,
  'switch-country--medium': switchCountryMedium,
  'switch-country--small': switchCountrySmall,
  'terrain--medium': terrainMedium,
  'terrain--small': terrainSmall,
  'test-drive--medium': testDriveMedium,
  'test-drive--small': testDriveSmall,
  'three-d-view--medium': threeDViewMedium,
  'three-d-view--small': threeDViewSmall,
  'tiktok--medium': tiktokMedium,
  'tiktok--small': tiktokSmall,
  'tires--medium': tiresMedium,
  'tires--small': tiresSmall,
  'trailer-hitch--medium': trailerHitchMedium,
  'trailer-hitch--small': trailerHitchSmall,
  'trunk-locked--medium': trunkLockedMedium,
  'trunk-locked--small': trunkLockedSmall,
  'trunk-unlocked--medium': trunkUnlockedMedium,
  'trunk-unlocked--small': trunkUnlockedSmall,
  'twentyfour-h-open--medium': twentyfourHOpenMedium,
  'twentyfour-h-open--small': twentyfourHOpenSmall,
  'twitter--medium': twitterMedium,
  'twitter--small': twitterSmall,
  'unfold-more--medium': unfoldMoreMedium,
  'unfold-more--small': unfoldMoreSmall,
  'unlock--medium': unlockMedium,
  'unlock--small': unlockSmall,
  'upload--medium': uploadMedium,
  'upload--small': uploadSmall,
  'vehicle-service-maintenance--medium': vehicleServiceMaintenanceMedium,
  'vehicle-service-maintenance--small': vehicleServiceMaintenanceSmall,
  'view-exterior--medium': viewExteriorMedium,
  'view-exterior--small': viewExteriorSmall,
  'view-interior--medium': viewInteriorMedium,
  'view-interior--small': viewInteriorSmall,
  'volume-no-sound--medium': volumeNoSoundMedium,
  'volume-no-sound--small': volumeNoSoundSmall,
  'volume-off--medium': volumeOffMedium,
  'volume-off--small': volumeOffSmall,
  'volume-on--medium': volumeOnMedium,
  'volume-on--small': volumeOnSmall,
  'volume-reduce--medium': volumeReduceMedium,
  'volume-reduce--small': volumeReduceSmall,
  'wallbox--medium': wallboxMedium,
  'wallbox--small': wallboxSmall,
  'warning--medium': warningMedium,
  'warning--small': warningSmall,
  'watch-wish-list--medium': watchWishListMedium,
  'watch-wish-list--small': watchWishListSmall,
  'windows-closed--medium': windowsClosedMedium,
  'windows-closed--small': windowsClosedSmall,
  'windows-vent--medium': windowsVentMedium,
  'windows-vent--small': windowsVentSmall,
  'youtube--medium': youtubeMedium,
  'youtube--small': youtubeSmall
} as const;

export const IconNamesSmall = {
  'acceleration-gauge--small': accelerationGaugeSmall,
  'account-logged-in--small': accountLoggedInSmall,
  'account--small': accountSmall,
  'account-camera--small': accountCameraSmall,
  'account-shop--small': accountShopSmall,
  'account-support--small': accountSupportSmall,
  'address-book--small': addressBookSmall,
  'alert--small': alertSmall,
  'appointment--small': appointmentSmall,
  'ar-function--small': arFunctionSmall,
  'arrow-down--small': arrowDownSmall,
  'arrow-left--small': arrowLeftSmall,
  'arrow-right--small': arrowRightSmall,
  'arrow-up--small': arrowUpSmall,
  'avoid-motorways--small': avoidMotorwaysSmall,
  'avoid-tolls--small': avoidTollsSmall,
  'battery--small': batterySmall,
  'bell--small': bellSmall,
  'bluetooth-controls--small': bluetoothControlsSmall,
  'burger-menu--small': burgerMenuSmall,
  'calculator--small': calculatorSmall,
  'calendar--small': calendarSmall,
  'call--small': callSmall,
  'car--small': carSmall,
  'car-pairing--small': carPairingSmall,
  'card-ui-payment--small': cardUiPaymentSmall,
  'cash-payment--small': cashPaymentSmall,
  'charge-battery-active--small': chargeBatteryActiveSmall,
  'charge-battery-inactive--small': chargeBatteryInactiveSmall,
  'charging-reports-ui-invoice-2--small': chargingReportsUiInvoice2Small,
  'checkbox-error--small': checkboxErrorSmall,
  'checkbox-semi-active--small': checkboxSemiActiveSmall,
  'chevron-compact-down--small': chevronCompactDownSmall,
  'chevron-compact-left--small': chevronCompactLeftSmall,
  'chevron-compact-right--small': chevronCompactRightSmall,
  'chevron-compact-up--small': chevronCompactUpSmall,
  'chevron-down--small': chevronDownSmall,
  'chevron-left--small': chevronLeftSmall,
  'chevron-right--small': chevronRightSmall,
  'chevron-up--small': chevronUpSmall,
  'chevron-up-down--small': chevronUpDownSmall,
  'climate-active--small': climateActiveSmall,
  'climate-inactive--small': climateInactiveSmall,
  'close-with-circle--small': closeWithCircleSmall,
  'close-without-circle--small': closeWithoutCircleSmall,
  'closed-captions--small': closedCaptionsSmall,
  'compare--small': compareSmall,
  'contact--small': contactSmall,
  'contract--small': contractSmall,
  'controls-guest-mode--small': controlsGuestModeSmall,
  'controls-sentry-mode--small': controlsSentryModeSmall,
  'controls-valet-mode--small': controlsValetModeSmall,
  'copy--small': copySmall,
  'dealer-locator-location--small': dealerLocatorLocationSmall,
  'delete--small': deleteSmall,
  'digital-service-book--small': digitalServiceBookSmall,
  'doors-locked--small': doorsLockedSmall,
  'doors-unlocked--small': doorsUnlockedSmall,
  'download--small': downloadSmall,
  'duration--small': durationSmall,
  'edit--small': editSmall,
  'emissions--small': emissionsSmall,
  'enter-code--small': enterCodeSmall,
  'error--small': errorSmall,
  'existing-customer--small': existingCustomerSmall,
  'exports--small': exportsSmall,
  'external-link--small': externalLinkSmall,
  'eye--small': eyeSmall,
  'eye-off--small': eyeOffSmall,
  'facebook--small': facebookSmall,
  'features--small': featuresSmall,
  'filter--small': filterSmall,
  'filter-active--small': filterActiveSmall,
  'filter-selected--small': filterSelectedSmall,
  'find-a-dealership--small': findADealershipSmall,
  'flash-active--small': flashActiveSmall,
  'flash-inactive--small': flashInactiveSmall,
  'full-size-image--small': fullSizeImageSmall,
  'garage-car-selection--small': garageCarSelectionSmall,
  'geofence--small': geofenceSmall,
  'gift--small': giftSmall,
  'green-energy--small': greenEnergySmall,
  'home-charging--small': homeChargingSmall,
  'home-company-direction--small': homeCompanyDirectionSmall,
  'horn-active--small': hornActiveSmall,
  'horn-inactive--small': hornInactiveSmall,
  'hotline--small': hotlineSmall,
  'i-charging-cable--small': iChargingCableSmall,
  'image--small': imageSmall,
  'in-car-navigation--small': inCarNavigationSmall,
  'indefinite--small': indefiniteSmall,
  'indoor--small': indoorSmall,
  'info-hide--small': infoHideSmall,
  'info-legal--small': infoLegalSmall,
  'instagram--small': instagramSmall,
  'kebab-menu-more--small': kebabMenuMoreSmall,
  'key-share-not-shared-key--small': keyShareNotSharedKeySmall,
  'key-share-shared-key--small': keyShareSharedKeySmall,
  'leasing--small': leasingSmall,
  'link--small': linkSmall,
  'linkedin--small': linkedinSmall,
  'live-chat--small': liveChatSmall,
  'locate-my-car--small': locateMyCarSmall,
  'locate-my-device--small': locateMyDeviceSmall,
  'location-marker-car--small': locationMarkerCarSmall,
  'location-marker-device--small': locationMarkerDeviceSmall,
  'location-marker-other-POI--small': locationMarkerOtherPoiSmall,
  'location-marker-public-charger--small': locationMarkerPublicChargerSmall,
  'lock--small': lockSmall,
  'log-out--small': logOutSmall,
  'manage-columns--small': manageColumnsSmall,
  'map-target--small': mapTargetSmall,
  'maximize--small': maximizeSmall,
  'meatballs-menu-more--small': meatballsMenuMoreSmall,
  'minimize--small': minimizeSmall,
  'minus--small': minusSmall,
  'mirroring--small': mirroringSmall,
  'new-customer--small': newCustomerSmall,
  'new-customized-car--small': newCustomizedCarSmall,
  'new-notification-with-badge--small': newNotificationWithBadgeSmall,
  'news--small': newsSmall,
  'newsletter-mail--small': newsletterMailSmall,
  'no-authorization--small': noAuthorizationSmall,
  'notification--small': notificationSmall,
  'on--small': onSmall,
  'open-in-maps--small': openInMapsSmall,
  'owners-manual--small': ownersManualSmall,
  'park-charge--small': parkChargeSmall,
  'parking-comfort-mode-active--small': parkingComfortModeActiveSmall,
  'parking-comfort-mode-inactive--small': parkingComfortModeInactiveSmall,
  'pause--small': pauseSmall,
  'pegman--small': pegmanSmall,
  'phone--small': phoneSmall,
  'phone-key-car-connected--small': phoneKeyCarConnectedSmall,
  'phone-key-car-disconnected--small': phoneKeyCarDisconnectedSmall,
  'phone-navigation-app--small': phoneNavigationAppSmall,
  'play-button--small': playButtonSmall,
  'plug-chademo--small': plugChademoSmall,
  'plug-charge--small': plugChargeSmall,
  'plug-css--small': plugCssSmall,
  'plug-household-a--small': plugHouseholdASmall,
  'plug-household-e--small': plugHouseholdESmall,
  'plug-household-f--small': plugHouseholdFSmall,
  'plug-household-g--small': plugHouseholdGSmall,
  'plug-household-j--small': plugHouseholdJSmall,
  'plug-type-1--small': plugType1Small,
  'plug-type-2--small': plugType2Small,
  'plug-type-3--small': plugType3Small,
  'plus--small': plusSmall,
  'print--small': printSmall,
  'qr-code--small': qrCodeSmall,
  'refresh--small': refreshSmall,
  'refresh-air-inactive--small': refreshAirInactiveSmall,
  'remote-controls--small': remoteControlsSmall,
  'restricted-access--small': restrictedAccessSmall,
  'reviews-empty--small': reviewsEmptySmall,
  'reviews-full--small': reviewsFullSmall,
  'roof--small': roofSmall,
  'satellite--small': satelliteSmall,
  'save-favourite--small': saveFavouriteSmall,
  'search--small': searchSmall,
  'seat-heat-drive-active-lvl1--small': seatHeatDriveActiveLvl1Small,
  'seat-heat-drive-active-lvl2--small': seatHeatDriveActiveLvl2Small,
  'seat-heat-drive-active-lvl3--small': seatHeatDriveActiveLvl3Small,
  'seat-heat-drive-inactive--small': seatHeatDriveInactiveSmall,
  'seat-heat-passenger-active-lvl1--small': seatHeatPassengerActiveLvl1Small,
  'seat-heat-passenger-active-lvl2--small': seatHeatPassengerActiveLvl2Small,
  'seat-heat-passenger-active-lvl3--small': seatHeatPassengerActiveLvl3Small,
  'seat-heat-passenger-inactive--small': seatHeatPassengerInactiveSmall,
  'send-to-car--small': sendToCarSmall,
  'service-app--small': serviceAppSmall,
  'setting--small': settingSmall,
  'share--small': shareSmall,
  'shopping-cart--small': shoppingCartSmall,
  'smart-dealer--small': smartDealerSmall,
  'sort-default--small': sortDefaultSmall,
  'status-good--small': statusGoodSmall,
  'steering-wheel-heat-active--small': steeringWheelHeatActiveSmall,
  'steering-wheel-heat-inactive--small': steeringWheelHeatInactiveSmall,
  'successful-checkmark--small': successfulCheckmarkSmall,
  'sunshade-closed--small': sunshadeClosedSmall,
  'sunshade-open--small': sunshadeOpenSmall,
  'support-help--small': supportHelpSmall,
  'switch-country--small': switchCountrySmall,
  'terrain--small': terrainSmall,
  'test-drive--small': testDriveSmall,
  'three-d-view--small': threeDViewSmall,
  'tiktok--small': tiktokSmall,
  'tires--small': tiresSmall,
  'trailer-hitch--small': trailerHitchSmall,
  'trunk-locked--small': trunkLockedSmall,
  'trunk-unlocked--small': trunkUnlockedSmall,
  'twentyfour-h-open--small': twentyfourHOpenSmall,
  'twitter--small': twitterSmall,
  'unfold-more--small': unfoldMoreSmall,
  'unlock--small': unlockSmall,
  'upload--small': uploadSmall,
  'vehicle-service-maintenance--small': vehicleServiceMaintenanceSmall,
  'view-exterior--small': viewExteriorSmall,
  'view-interior--small': viewInteriorSmall,
  'volume-no-sound--small': volumeNoSoundSmall,
  'volume-off--small': volumeOffSmall,
  'volume-on--small': volumeOnSmall,
  'volume-reduce--small': volumeReduceSmall,
  'wallbox--small': wallboxSmall,
  'warning--small': warningSmall,
  'watch-wish-list--small': watchWishListSmall,
  'windows-closed--small': windowsClosedSmall,
  'windows-vent--small': windowsVentSmall,
  'youtube--small': youtubeSmall
} as const;

export const IconNamesMedium = {
  'acceleration-gauge--medium': accelerationGaugeMedium,
  'account-logged-in--medium': accountLoggedInMedium,
  'account--medium': accountMedium,
  'account-camera--medium': accountCameraMedium,
  'account-shop--medium': accountShopMedium,
  'account-support--medium': accountSupportMedium,
  'address-book--medium': addressBookMedium,
  'alert--medium': alertMedium,
  'appointment--medium': appointmentMedium,
  'ar-function--medium': arFunctionMedium,
  'arrow-down--medium': arrowDownMedium,
  'arrow-left--medium': arrowLeftMedium,
  'arrow-right--medium': arrowRightMedium,
  'arrow-up--medium': arrowUpMedium,
  'avoid-motorways--medium': avoidMotorwaysMedium,
  'avoid-tolls--medium': avoidTollsMedium,
  'battery--medium': batteryMedium,
  'bell--medium': bellMedium,
  'bluetooth-controls--medium': bluetoothControlsMedium,
  'burger-menu--medium': burgerMenuMedium,
  'calculator--medium': calculatorMedium,
  'calendar--medium': calendarMedium,
  'call--medium': callMedium,
  'car--medium': carMedium,
  'car-pairing--medium': carPairingMedium,
  'card-ui-payment--medium': cardUiPaymentMedium,
  'cash-payment--medium': cashPaymentMedium,
  'charge-battery-active--medium': chargeBatteryActiveMedium,
  'charge-battery-inactive--medium': chargeBatteryInactiveMedium,
  'charging-reports-ui-invoice-2--medium': chargingReportsUiInvoice2Medium,
  'checkbox-error--medium': checkboxErrorMedium,
  'checkbox-semi-active--medium': checkboxSemiActiveMedium,
  'chevron-compact-down--medium': chevronCompactDownMedium,
  'chevron-compact-left--medium': chevronCompactLeftMedium,
  'chevron-compact-right--medium': chevronCompactRightMedium,
  'chevron-compact-up--medium': chevronCompactUpMedium,
  'chevron-down--medium': chevronDownMedium,
  'chevron-left--medium': chevronLeftMedium,
  'chevron-right--medium': chevronRightMedium,
  'chevron-up--medium': chevronUpMedium,
  'chevron-up-down--medium': chevronUpDownMedium,
  'climate-active--medium': climateActiveMedium,
  'climate-inactive--medium': climateInactiveMedium,
  'close-with-circle--medium': closeWithCircleMedium,
  'close-without-circle--medium': closeWithoutCircleMedium,
  'closed-captions--medium': closedCaptionsMedium,
  'compare--medium': compareMedium,
  'contact--medium': contactMedium,
  'contract--medium': contractMedium,
  'controls-guest-mode--medium': controlsGuestModeMedium,
  'controls-sentry-mode--medium': controlsSentryModeMedium,
  'controls-valet-mode--medium': controlsValetModeMedium,
  'copy--medium': copyMedium,
  'dealer-locator-location--medium': dealerLocatorLocationMedium,
  'delete--medium': deleteMedium,
  'digital-service-book--medium': digitalServiceBookMedium,
  'doors-locked--medium': doorsLockedMedium,
  'doors-unlocked--medium': doorsUnlockedMedium,
  'download--medium': downloadMedium,
  'duration--medium': durationMedium,
  'edit--medium': editMedium,
  'emissions--medium': emissionsMedium,
  'enter-code--medium': enterCodeMedium,
  'error--medium': errorMedium,
  'existing-customer--medium': existingCustomerMedium,
  'exports--medium': exportsMedium,
  'external-link--medium': externalLinkMedium,
  'eye--medium': eyeMedium,
  'eye-off--medium': eyeOffMedium,
  'facebook--medium': facebookMedium,
  'features--medium': featuresMedium,
  'filter--medium': filterMedium,
  'filter-active--medium': filterActiveMedium,
  'filter-selected--medium': filterSelectedMedium,
  'find-a-dealership--medium': findADealershipMedium,
  'flash-active--medium': flashActiveMedium,
  'flash-inactive--medium': flashInactiveMedium,
  'full-size-image--medium': fullSizeImageMedium,
  'garage-car-selection--medium': garageCarSelectionMedium,
  'geofence--medium': geofenceMedium,
  'gift--medium': giftMedium,
  'green-energy--medium': greenEnergyMedium,
  'home-charging--medium': homeChargingMedium,
  'home-company-direction--medium': homeCompanyDirectionMedium,
  'horn-active--medium': hornActiveMedium,
  'horn-inactive--medium': hornInactiveMedium,
  'hotline--medium': hotlineMedium,
  'i-charging-cable--medium': iChargingCableMedium,
  'image--medium': imageMedium,
  'in-car-navigation--medium': inCarNavigationMedium,
  'indefinite--medium': indefiniteMedium,
  'indoor--medium': indoorMedium,
  'info-hide--medium': infoHideMedium,
  'info-legal--medium': infoLegalMedium,
  'instagram--medium': instagramMedium,
  'kebab-menu-more--medium': kebabMenuMoreMedium,
  'key-share-not-shared-key--medium': keyShareNotSharedKeyMedium,
  'key-share-shared-key--medium': keyShareSharedKeyMedium,
  'leasing--medium': leasingMedium,
  'link--medium': linkMedium,
  'linkedin--medium': linkedinMedium,
  'live-chat--medium': liveChatMedium,
  'locate-my-car--medium': locateMyCarMedium,
  'locate-my-device--medium': locateMyDeviceMedium,
  'location-marker-car--medium': locationMarkerCarMedium,
  'location-marker-device--medium': locationMarkerDeviceMedium,
  'location-marker-other-POI--medium': locationMarkerOtherPoiMedium,
  'location-marker-public-charger--medium': locationMarkerPublicChargerMedium,
  'lock--medium': lockMedium,
  'log-out--medium': logOutMedium,
  'manage-columns--medium': manageColumnsMedium,
  'map-target--medium': mapTargetMedium,
  'maximize--medium': maximizeMedium,
  'meatballs-menu-more--medium': meatballsMenuMoreMedium,
  'minimize--medium': minimizeMedium,
  'minus--medium': minusMedium,
  'mirroring--medium': mirroringMedium,
  'new-customer--medium': newCustomerMedium,
  'new-customized-car--medium': newCustomizedCarMedium,
  'new-notification-with-badge--medium': newNotificationWithBadgeMedium,
  'news--medium': newsMedium,
  'newsletter-mail--medium': newsletterMailMedium,
  'no-authorization--medium': noAuthorizationMedium,
  'notification--medium': notificationMedium,
  'on--medium': onMedium,
  'open-in-maps--medium': openInMapsMedium,
  'owners-manual--medium': ownersManualMedium,
  'park-charge--medium': parkChargeMedium,
  'parking-comfort-mode-active--medium': parkingComfortModeActiveMedium,
  'parking-comfort-mode-inactive--medium': parkingComfortModeInactiveMedium,
  'pause--medium': pauseMedium,
  'pegman--medium': pegmanMedium,
  'phone--medium': phoneMedium,
  'phone-key-car-connected--medium': phoneKeyCarConnectedMedium,
  'phone-key-car-disconnected--medium': phoneKeyCarDisconnectedMedium,
  'phone-navigation-app--medium': phoneNavigationAppMedium,
  'play-button--medium': playButtonMedium,
  'plug-chademo--medium': plugChademoMedium,
  'plug-charge--medium': plugChargeMedium,
  'plug-css--medium': plugCssMedium,
  'plug-household-a--medium': plugHouseholdAMedium,
  'plug-household-e--medium': plugHouseholdEMedium,
  'plug-household-f--medium': plugHouseholdFMedium,
  'plug-household-g--medium': plugHouseholdGMedium,
  'plug-household-j--medium': plugHouseholdJMedium,
  'plug-type-1--medium': plugType1Medium,
  'plug-type-2--medium': plugType2Medium,
  'plug-type-3--medium': plugType3Medium,
  'plus--medium': plusMedium,
  'print--medium': printMedium,
  'qr-code--medium': qrCodeMedium,
  'refresh--medium': refreshMedium,
  'refresh-air-inactive--medium': refreshAirInactiveMedium,
  'remote-controls--medium': remoteControlsMedium,
  'restricted-access--medium': restrictedAccessMedium,
  'reviews-empty--medium': reviewsEmptyMedium,
  'reviews-full--medium': reviewsFullMedium,
  'roof--medium': roofMedium,
  'satellite--medium': satelliteMedium,
  'save-favourite--medium': saveFavouriteMedium,
  'save-favourite-full--medium': saveFavouriteFullMedium,
  'search--medium': searchMedium,
  'seat-heat-drive-active-lvl1--medium': seatHeatDriveActiveLvl1Medium,
  'seat-heat-drive-active-lvl2--medium': seatHeatDriveActiveLvl2Medium,
  'seat-heat-drive-active-lvl3--medium': seatHeatDriveActiveLvl3Medium,
  'seat-heat-drive-inactive--medium': seatHeatDriveInactiveMedium,
  'seat-heat-passenger-active-lvl1--medium': seatHeatPassengerActiveLvl1Medium,
  'seat-heat-passenger-active-lvl2--medium': seatHeatPassengerActiveLvl2Medium,
  'seat-heat-passenger-active-lvl3--medium': seatHeatPassengerActiveLvl3Medium,
  'seat-heat-passenger-inactive--medium': seatHeatPassengerInactiveMedium,
  'send-to-car--medium': sendToCarMedium,
  'service-app--medium': serviceAppMedium,
  'setting--medium': settingMedium,
  'share--medium': shareMedium,
  'shopping-cart--medium': shoppingCartMedium,
  'smart-dealer--medium': smartDealerMedium,
  'sort-default--medium': sortDefaultMedium,
  'status-good--medium': statusGoodMedium,
  'steering-wheel-heat-active--medium': steeringWheelHeatActiveMedium,
  'steering-wheel-heat-inactive--medium': steeringWheelHeatInactiveMedium,
  'successful-checkmark--medium': successfulCheckmarkMedium,
  'sunshade-closed--medium': sunshadeClosedMedium,
  'sunshade-open--medium': sunshadeOpenMedium,
  'support-help--medium': supportHelpMedium,
  'switch-country--medium': switchCountryMedium,
  'terrain--medium': terrainMedium,
  'test-drive--medium': testDriveMedium,
  'three-d-view--medium': threeDViewMedium,
  'tiktok--medium': tiktokMedium,
  'tires--medium': tiresMedium,
  'trailer-hitch--medium': trailerHitchMedium,
  'trunk-locked--medium': trunkLockedMedium,
  'trunk-unlocked--medium': trunkUnlockedMedium,
  'twentyfour-h-open--medium': twentyfourHOpenMedium,
  'twitter--medium': twitterMedium,
  'unfold-more--medium': unfoldMoreMedium,
  'unlock--medium': unlockMedium,
  'upload--medium': uploadMedium,
  'vehicle-service-maintenance--medium': vehicleServiceMaintenanceMedium,
  'view-exterior--medium': viewExteriorMedium,
  'view-interior--medium': viewInteriorMedium,
  'volume-no-sound--medium': volumeNoSoundMedium,
  'volume-off--medium': volumeOffMedium,
  'volume-on--medium': volumeOnMedium,
  'volume-reduce--medium': volumeReduceMedium,
  'wallbox--medium': wallboxMedium,
  'warning--medium': warningMedium,
  'watch-wish-list--medium': watchWishListMedium,
  'windows-closed--medium': windowsClosedMedium,
  'windows-vent--medium': windowsVentMedium,
  'youtube--medium': youtubeMedium
} as const;

export type IconType = keyof typeof IconNames;
export type IconSmallType = keyof typeof IconNamesSmall;
export type IconMediumType = keyof typeof IconNamesMedium;
